let audio: AudioContext | null = null;
let noise: AudioBuffer | null = null;

function context(): AudioContext | null {
  const Ctx = window.AudioContext || (window as Window & { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
  if (!Ctx) return null;
  if (!audio) audio = new Ctx();
  if (audio.state === 'suspended') void audio.resume();
  return audio;
}

function noiseBuffer(ctx: AudioContext): AudioBuffer {
  if (noise && noise.sampleRate === ctx.sampleRate) return noise;
  const length = ctx.sampleRate;
  const buffer = ctx.createBuffer(1, length, ctx.sampleRate);
  const data = buffer.getChannelData(0);
  for (let i = 0; i < length; i += 1) data[i] = Math.random() * 2 - 1;
  noise = buffer;
  return buffer;
}

function clipCurve(): Float32Array<ArrayBuffer> {
  const curve = new Float32Array(512);
  for (let i = 0; i < curve.length; i += 1) {
    const x = (i / (curve.length / 2)) - 1;
    curve[i] = Math.tanh(x * 6);
  }
  return curve;
}

function blast(ctx: AudioContext, start: number, seconds: number) {
  const master = ctx.createGain();
  master.gain.setValueAtTime(0.0001, start);
  master.gain.exponentialRampToValueAtTime(0.7, start + 0.02);
  master.gain.setValueAtTime(0.7, start + Math.max(0.05, seconds - 0.08));
  master.gain.exponentialRampToValueAtTime(0.0001, start + seconds);
  master.connect(ctx.destination);

  const shaper = ctx.createWaveShaper();
  shaper.curve = clipCurve();
  shaper.oversample = '2x';
  shaper.connect(master);

  const low = ctx.createOscillator();
  low.type = 'square';
  low.frequency.setValueAtTime(95, start);
  const mid = ctx.createOscillator();
  mid.type = 'sawtooth';
  mid.frequency.setValueAtTime(190, start);
  const tone = ctx.createGain();
  tone.gain.value = 0.55;
  low.connect(tone);
  mid.connect(tone);
  tone.connect(shaper);

  const rasp = ctx.createBufferSource();
  rasp.buffer = noiseBuffer(ctx);
  rasp.loop = true;
  const filter = ctx.createBiquadFilter();
  filter.type = 'bandpass';
  filter.frequency.value = 900;
  filter.Q.value = 0.6;
  const raspGain = ctx.createGain();
  raspGain.gain.value = 0.35;
  rasp.connect(filter);
  filter.connect(raspGain);
  raspGain.connect(shaper);

  low.start(start);
  mid.start(start);
  rasp.start(start);
  low.stop(start + seconds);
  mid.stop(start + seconds);
  rasp.stop(start + seconds);
}

export function unlockBuzzer() {
  const ctx = context();
  if (!ctx) return;
  if (ctx.state === 'suspended') void ctx.resume();
}

export function playBuzzer() {
  const ctx = context();
  if (!ctx) return;
  const sound = () => blast(ctx, ctx.currentTime + 0.02, 1.6);
  if (ctx.state === 'suspended') {
    void ctx.resume().then(sound);
    return;
  }
  sound();
}
